<template>
  <svg
    viewBox="0 0 76 80"
    width="16"
    height="16"
    fill="currentColor"
    aria-hidden="true">
    <path
      d="M69.764 29.46476c1.92603 1.02293 3.53727 2.55086 4.66092 4.41992 1.12365 1.86906 1.71731 4.00875 1.71731 6.18958 0 2.18082-0.59366 4.32051-1.71731 6.18957-1.12365 1.86907-2.73489 3.397-4.66092 4.41992l-51.343 27.916c-8.265 4.5-18.421-1.352-18.421-10.60499l0-55.841c0-9.254 10.156-15.103 18.421-10.609l51.343 27.92z" />
  </svg>
</template>
